module.exports = __webpack_public_path__ + "static/media/ehl-setup.751724ea.jpg";